



































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import BusinessUpdateGeneral from './Update/BusinessUpdateGeneral.vue';
import BusinessUpdateContactList from './Update/BusinessUpdateContactList.vue';
import BusinessUpdateAddressList from './Update/BusinessUpdateAddressList.vue';
import BusinessUpdateUserList from './Update/BusinessUpdateUserList.vue';
import BusinessUpdateBookingList from './Update/BusinessUpdateBookingList.vue';
import BusinessUpdateTags from './Update/BusinessUpdateTags.vue';
import BusinessUpdatePreference from './Update/BusinessUpdatePreference.vue';

@Component({
  components: {
    BusinessUpdateGeneral,
    BusinessUpdateContactList,
    BusinessUpdateAddressList,
    BusinessUpdateUserList,
    BusinessUpdateBookingList,
    BusinessUpdateTags,
    BusinessUpdatePreference,
  },
  computed: {
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
    ...mapState('Country', {
      countries: 'countries',
    }),
  },
})
export default class BusinessUpdate extends Vue {
  isMounted = false;

  activeBusiness!: Model;
  countries!: [];

  sidebarItems = [
    {
      title: 'General',
    },
    {
      title: 'Contacts',
    },
    {
      title: 'Addresses',
    },
    {
      title: 'Team',
    },
    {
      title: 'Booking History',
    },
    {
      title: 'Tags',
    },
    {
      title: 'Advanced Setting',
    },
  ];

  sidebarIndex = 0;

  @Watch('activeBusiness', { deep: true })
  watchActiveBusiness() {
    this.init();
  }

  async created() {
    if (this.countries.length === 0) {
      await this.$store.dispatch('Country/fetchList');
    }
    this.init();
  }

  init() {
    this.$store
      .dispatch('Business/fetch', {
        businessOid: this.activeBusiness.object_id,
        config: {
          params: {
            expand: [
              'business_contacts',
              'business_addresses',
              'billing_address',
              'billing_contact',
              'postal_address',
              'primary_contact',
              'director_contact',
              'user_preference',
            ],
          },
        },
      })
      .then(() => {
        this.isMounted = true;
      });
  }
}
